import React from 'react';
import CategoryList from '../components/settings/CategoryList';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { TagIcon } from '@heroicons/react/24/outline';

const Categories = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4 pb-20 sm:pb-6">
      <CommonPageHeader
        title={t('settings.categories.title')}
        subtitle={t('settings.categories.subtitle') || 'Kategóriák kezelése és szervezése'}
        icon={TagIcon}
      />
      <CategoryList />
    </div>
  );
};

export default Categories; 